

























































// Vue
import { Component, Vue } from 'vue-property-decorator'

// Components
import { DataTable } from '../../table'
import { IsActive } from '@/components'

// services
import { SubAreaService } from '@/services/config'

// Models
import { Paginator } from '@/models'
import { SubAreaModel } from '@/models/config'

@Component({
    name: 'TableListSubAreas',
    components: {
        DataTable,
        IsActive
    }
})
export default class TableListSubAreas extends Vue {
    loading = false
    items: [SubAreaModel] | [] = []
    pagination: Paginator = {
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
    }

    fields = [
        {
            key: 'area.name',
            sortable: true,
            label: 'Area'
        },
        {
            key: 'name',
            sortable: true,
            label: 'Nombre'
        },
        {
            key: 'description',
            sortable: true,
            label: 'Descripción'
        },
        {
            key: 'is_group_piecework',
            sortable: true,
            label: 'Destajo Grupal',
            formatter: (value: boolean) => {
                return value ? 'SI' : 'NO'
            }
        },
        {
            key: 'status_text',
            sortable: true,
            label: 'Status'
        },
        {
            key: 'actions',
            sortable: false,
            label: '',
            thClass: 'one-line w-30',
            thStyle: {
                width: '15%'
            }
        }
    ]

    created () {
        this.getSubAreasWithPagination()
    }

    changePage (page: number) {
        this.pagination.currentPage = page
        this.getSubAreasWithPagination()
    }

    changePerPage (perPage: number) {
        this.pagination.perPage = perPage
        this.pagination.currentPage = 1
        this.getSubAreasWithPagination()
    }

    async getSubAreasWithPagination () {
        this.loading = true
        const response = await SubAreaService.getWithPagination(this.pagination.perPage, this.pagination.currentPage)
        this.items = response.objects
        this.pagination = response.pagination
        this.loading = false
    }
}
